import {ReactElement} from "react";
import {PD_LG, PD_XLG, PD_XLG3, PD_XXXLG} from "@/shared/dimens";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {LargeButton} from "./SharedComponents";
import {useMediaQuery, useTheme} from "@mui/material";
import {HeroSectionData, SiteTemplate} from "../../types";

export function HeroSection(props: { data: HeroSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <div style={{
    display: "flex",
    flexDirection: md ? "row" : "column-reverse",
    minHeight: md ? 600 : "auto",
    backgroundColor: props.template.themeExtras.highlightColor,
    overflow: "hidden",
  }}>
    <StyledBoxColumn style={{
      flex: 1,
      justifyContent: "center",
      padding: md ? `${PD_XXXLG}px ${PD_XLG3}px` : `${PD_XLG}px ${PD_LG}px`,
      gap: PD_XLG,
    }}>
      <StyledHeadingVariant default_={1} style={{
        color: theme.palette.primary.main,
        lineHeight: 1.05,
        maxWidth: 480,
      }}>
        {props.data.title}
      </StyledHeadingVariant>
      <StyledBoxRow style={{gap: PD_LG, flexWrap: "wrap"}}>
        {props.data.primaryLink?.text
          ? <LargeButton
            href={props.data.primaryLink.url}
            variant={"contained"}>
            {props.data.primaryLink.text}
          </LargeButton>
          : null}
        {props.data.secondaryLink?.text
          ? <LargeButton
            href={props.data.secondaryLink.url}
            variant={"outlined"}>
            {props.data.secondaryLink.text}
          </LargeButton>
          : null}
      </StyledBoxRow>
    </StyledBoxColumn>
    <div style={{
      flex: md ? 1.1 : "none",
      height: md ? "auto" : 280,
      position: "relative",
    }}>
      <img
        src={props.data.imageUrl}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          objectFit: "cover",
          objectPosition: "center top",
        }}/>
    </div>
  </div>;
}
